import request from '@/utils/request'

/**
 * 获取报价书
 * @param data
 * @returns {AxiosPromise}
 */
export function getOfferBookList(data) {
  return request({
    url: 'api/getOfferBookList',
    method: 'get',
    params: data
  })
}

/**
 * 获取报价书详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getOfferBookDetail(data) {
  return request({
    url: 'api/getOfferBookDetail',
    method: 'get',
    params: data
  })
}

/**
 * 创建/修改报价书
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditOfferBook(data) {
  return request({
    url: 'api/addOrEditOfferBook',
    method: 'post',
    params: data
  })
}

/**
 * 删除报价书
 * @param data
 * @returns {AxiosPromise}
 */
export function delOfferBook(data) {
  return request({
    url: 'api/delOfferBook',
    method: 'post',
    params: data
  })
}

/**
 * 创建/修改报价书分类
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditOfferClassify(data) {
  return request({
    url: 'api/addOrEditOfferClassify',
    method: 'post',
    params: data
  })
}

/**
 * 删除报价书分类
 * @param data
 * @returns {AxiosPromise}
 */
export function delOfferClassify(data) {
  return request({
    url: 'api/delOfferClassify',
    method: 'post',
    params: data
  })
}
